import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  location: string;
  quote: string;
  result: string;
  profilePlaceholder: string;
  workPlaceholder: string;
  profileImage?: string;
  workImage?: string;
}
export function TestimonialCard({
  name,
  age,
  location,
  quote,
  result,
  profilePlaceholder,
  workPlaceholder,
  profileImage,
  workImage
}: TestimonialCardProps) {
  return <div className="bg-[#1C1208] border border-[#2A1F0A] rounded-xl overflow-hidden flex flex-col h-full" data-id="element-296">
      {/* Work Photo */}
      <div className="h-48 bg-[#111111] relative border-b border-[#2A1F0A] flex items-center justify-center overflow-hidden group" data-id="element-297">
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1208] to-transparent opacity-60 z-10" data-id="element-298"></div>
        {workImage ? <img src={workImage} alt={workPlaceholder} className="absolute inset-0 w-full h-full object-cover" data-id="element-299" /> : <span className="text-[#C8B89A] text-sm z-20 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-300">
            [FOTO TRABAJO — {workPlaceholder}]
          </span>}
      </div>

      <div className="p-6 flex-1 flex flex-col relative" data-id="element-301">
        {/* Profile Photo */}
        <div className="absolute -top-10 left-6 w-16 h-16 rounded-full bg-[#2A1F0A] border-4 border-[#1C1208] flex items-center justify-center overflow-hidden z-20" data-id="element-302">
          {profileImage ? <img src={profileImage} alt={name} className="w-full h-full object-cover" data-id="element-303" /> : <span className="text-[#D4A843] text-[10px] text-center leading-tight px-1" data-id="element-304">
              [FOTO]
            </span>}
        </div>

        <div className="mt-6 flex gap-1 mb-4" data-id="element-305">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D4A843] text-[#D4A843]" data-id="element-306" />)}
        </div>

        <blockquote className="text-white text-base md:text-lg italic mb-6 flex-1" data-id="element-307">
          "{quote}"
        </blockquote>

        <div className="mt-auto pt-4 border-t border-[#2A1F0A]" data-id="element-308">
          <p className="font-bold text-[#D4A843]" data-id="element-309">
            {name}, {age} años
          </p>
          <p className="text-[#C8B89A] text-sm mb-2" data-id="element-310">{location}</p>
          <p className="text-[#FF8C00] text-sm font-medium bg-[#FF8C00]/10 inline-block px-3 py-1 rounded-full" data-id="element-311">
            {result}
          </p>
        </div>
      </div>
    </div>;
}